/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTile_item = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_item" | "Product_item">;
    readonly " $refType": "ItemTile_item";
};
export type ItemTile_item$data = ItemTile_item;
export type ItemTile_item$key = {
    readonly " $data"?: ItemTile_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTile_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isTrade",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "showSeller",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "pageDisplayEnum",
      "type": "PageDisplayEnum",
      "defaultValue": "searchAndBrowse"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemTileBase_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "Product_item",
      "args": null
    }
  ]
};
(node as any).hash = 'fb3c00842f0f3acbb691c3884f0f46a3';
export default node;
